import Swiper from "swiper";
import SwiperCore, {Navigation, Autoplay, Pagination, Lazy} from "swiper/core";

SwiperCore.use([Navigation, Autoplay, Pagination, Lazy]);
import catalogItem from "../catalogItem/catalogItem.js";
import {getElement} from "../modules/helpers.js";

export default function slidersHomePage() {
    if (getElement(`[data-swiper="promo"]`)) {
        const swiperPromo = new Swiper(
            document.querySelector(`[data-swiper="promo"]`),
            {
                slidesPerView: 1,
                slideClass: "swiper-slide",
                loop: true,
                init: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: `.slider__next-promo-section`,
                    prevEl: `.slider__prev-promo-section`,
                },

            }
        );
    }
    if (getElement('[data-swiper="main-screen"]')?.querySelectorAll('.swiper-slide').length > 1) {
        const swiperMainScreen = new Swiper(
            document.querySelector(`[data-swiper="main-screen"]`),
            {
                slidesPerView: 1,
                slideClass: "swiper-slide",
                loop: true,
                init: true,
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                    el: ".swiper-pagination-main-slider",
                    clickable: true,
                },
            }
        );
    }

    catalogItem(popularProduct);
    homePageSectionSlider("popular", "catalog-item", {
        1600: {
            slidesPerView: 5,
        },
        1024: {
            slidesPerView: 4,

        },
        768: {
            slidesPerView: 2,

        },
        767: {
            slidesPerView: 1.5,
        }
    });
    homePageSectionSlider("liked", "liked-item", {
        1920: {
            slidesPerView: 7,
        },

        1440: {
            slidesPerView: 6,
        },
        1200: {
            slidesPerView: 5,
        },

        768: {
            slidesPerView: 4,
        },
        767: {
            slidesPerView: 1.5,
        }
    });
    homePageSectionSlider("viewed", "catalog-item", {
        1920: {
            slidesPerView: 7,
        },

        1190: {
            slidesPerView: 5,
        },
        1024: {
            slidesPerView: 4,
        },
        768: {
            slidesPerView: 3,
        },
        767: {
            slidesPerView: 1.5,
        }
    })

    function homePageSectionSlider(el, clazz, breakpoints) {

        new Swiper(document.querySelector(`[data-swiper="${el}"]`), {
            slidesPerView: 1.5,
            spaceBetween: 20,
            slideClass: clazz,
            navigation: {
                nextEl: `.slider__next-${el}`,
                prevEl: `.slider__prev-${el}`,
            },
            init: true,

            autoplay: {
                delay: 5000,
            },
            preloadImages: false,
            lazy: true,
            grabCursor: true,
            breakpoints: breakpoints,
        });

    }


}